import { camelize } from '@src/packages/dashboard/utils';

import { COLORS_PALETTE } from '../../../constants';

export const transformPieChartData = (result) => {
  const { data: agg } = camelize(result);
  
  if (!agg) {
    return {
      data: {
        metrics: [],
        info: {
          totalEvents: 0,
          division: {},
          eventType: {},
          trigger: {},
        },
      },
    };
  }

  const hits = agg?.hits || {};
  const totalEvents = hits?.total?.value ?? 0;
  const extraInfo = hits?.hits?.[0]?.source;

  const buckets = agg?.aggregations?.eventsPerTrigger?.buckets;
  
  if (!buckets || !Array.isArray(buckets)) {
    return {
      data: {
        metrics: [],
        info: {
          totalEvents,
          division: extraInfo?.division || {},
          eventType: extraInfo?.eventType || {},
          trigger: extraInfo?.trigger || {},
        },
      },
    };
  }

  const formatedData = buckets
    .filter(({ docCount }) => docCount > 0)
    .map(({ triggerName, docCount }, index) => ({
      name: triggerName?.hits?.hits?.[0]?.source?.trigger?.name,
      value: docCount,
      color: COLORS_PALETTE[index % COLORS_PALETTE.length],
    }));

  return {
    data: {
      metrics: formatedData,
      info: {
        totalEvents,
        division: extraInfo?.division || {},
        eventType: extraInfo?.eventType || {},
        trigger: extraInfo?.trigger || {},
      },
    },
  };
};

